/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./images.defs.js";
export { main as default } from "./images.defs.js";
